import React from 'react';
import './lib/installLazyRetry'; // #2713: must run before any screen module calls React.lazy
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installCrmAuthFetch } from './lib/crmAuthFetch';
import { installAppUpdate } from './lib/appUpdate';
import { installErrorReporter } from './lib/errorReporter';

// #2358: attach the session token to /api/crm calls.
installCrmAuthFetch();
// An installed phone app can sit on an old build for days: check on every return to the foreground and tell him (a small toast, only when idle, at most once an hour). Never reloads by itself.
installAppUpdate();
// Crash telemetry: window errors and unhandled promise rejections go to app_errors (never blocks, rate limited).
installErrorReporter();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
